import Service from "../../../Services/index";

const RateBonusSale = {
    namespaced: true,
    state: {
        rateBonusList: [],
        rateBonusForm: {
            id: "",
            name: "",
            start_price: "",
            end_price: "",
            bonus: "",
            user_id: "",
        },
        search: {
            name: ""
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        rate_bonus_array: [],
        rate_bonus_sale: []
    },
    mutations: {
        GET_RATE_BONUS_SALE: (state, res) => {
            state.rateBonusList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_RATE_BONUS_SALE_BY_ID: (state, res) => {
            state.rateBonusForm = res;
        },
        CLEAR_DATA_FORM: state => {
            state.rateBonusForm = {
                id: "",
                name: "",
                start_price: "",
                end_price: "",
                bonus: "",
                user_id: "",
            };
            state.rate_bonus_array = [];
        },
        ADD_SALE_BONUS_TO_ARRAY: (state) => {
            state.rate_bonus_array = [
                ...state.rate_bonus_array,
                {
                    start_price: "",
                    end_price: "",
                    bonus: "",
                }
            ];
        },
        REMOVE_RATE_BONUS_SALE: (state, index) => {
            state.rate_bonus_array = state.rate_bonus_array.filter(
                (detail, itemIndex) => index !== itemIndex
            )
        }
    },
    actions: {
        setRateBonusSale({commit}, page = 1) {
            return Service.RateBonusSale.getRateBonusSale(page).then(response => {
                commit("GET_RATE_BONUS_SALE", response);
            });
        },
        show({commit}, id) {
            return Service.RateBonusSale.showRateBonusSale(id).then(response => {
                commit("GET_RATE_BONUS_SALE_BY_ID", response);
            });
        },
        save({state}, {id, data}) {
            let info = {
                rate_bonus_sale: data
            };
            //console.log(info);
            if (!id) {
                return Service.RateBonusSale.createRateBonusSale(info).then(res => {
                    //console.log(res);
                });
            } else {
                return Service.RateBonusSale.updateRateBonusSale(id, data).then(res => {
                    //console.log(res);
                });
            }
        },
        addSaleBonusArray({commit}) {
            commit("ADD_SALE_BONUS_TO_ARRAY")
        },
        delete({commit}, id) {
            return Service.RateBonusSale.deleteRateBonusSale(id);
        },
        removeRateBonusArray({commit}, index) {
            commit("REMOVE_RATE_BONUS_SALE", index);
        },
        clearDataForm({commit}) {
            commit("CLEAR_DATA_FORM");
        },
        search({commit}, data) {
            return Service.RateBonusSale.searchRateBonusSale(data).then(res => {
                commit("GET_RATE_BONUS_SALE", res);
            })
        }

    }
};
export default RateBonusSale;
